import { a as __rest } from '../../tslib.es6.esm.js';
import { jsx } from 'react/jsx-runtime';
import { timestampStyles } from './Timestamp.styles.esm.js';
import { useTimestampFormat } from './useTimestamp.esm.js';
import { cn } from '../../utils/cn.esm.js';

/**
 * The Timestamp component renders a date in a relative, human-readable format.
 * It's unstyled by default and should be wrapped in typography components like Body.
 *
 */
const Timestamp = (_a) => {
    var { value, className, children, inverse } = _a, props = __rest(_a, ["value", "className", "children", "inverse"]);
    const formattedDate = useTimestampFormat(value);
    const isoDate = value instanceof Date ? value.toISOString() : new Date(value).toISOString();
    // Get styles for timestamp
    const { base } = timestampStyles({
        inverse,
    });
    const finalClassName = cn(base(), className);
    return (jsx("time", Object.assign({ className: finalClassName, dateTime: isoDate }, props, { children: formattedDate })));
};
Timestamp.displayName = "Timestamp";

export { Timestamp };
